var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from "vue-property-decorator";
import axios from "axios";
let OutsourceEntrance = class OutsourceEntrance extends Vue {
    controll = "";
    color = "#F44336";
    job = {
        order_nr: "",
        amount: 0,
        total_price: 0,
        order: {},
        supplier: {},
        get_goods: "",
        date: "",
    };
    suppliers = [];
    controlldisabled = false;
    snackbar = false;
    edit = false;
    Extern = [];
    text = "";
    dia = false;
    timeout = 0;
    index = 0;
    headers = [
        { text: 'Bestellnummer', value: 'order_nr' },
        { text: 'Offenemenge', value: 'amount' },
        { text: 'Notiz', value: 'note' },
        { text: 'Lieferant', value: 'supplier' },
        { text: 'lieferdatum', value: 'date' },
        { text: 'Aktionen', value: 'actions' },
    ];
    sendExtern() {
        axios.put('/api/extern/', { extern: this.Extern, job_id: this.controll }).then((response) => {
            this.text = "Die externen Aufträge wurden erfolgreich gespeichert";
            this.color = "green";
            this.snackbar = true;
            this.Extern = [];
        }).catch((error) => {
            this.text = "Der eingescannte Auftrag wurden nicht gefunden" + " Überprüfen sie die eigegebene Menge oder ob ein Interner Auftrag mit den eingecannten barcode vorhanden ist.";
            this.color = "red";
            this.snackbar = true;
        });
        this.snackbar = false;
        this.controlldisabled = false;
        this.controll = "";
    }
    getSupplierist() {
        axios.get('/api/suppliers').then((response) => {
            this.suppliers = response.data.data;
        });
        return this.suppliers;
    }
    diaopen() {
        this.controlldisabled = true;
        if (this.controll != '') {
            this.dia = true;
        }
    }
    createTemp() {
        if (this.edit) {
            // @ts-ignore
            this.Extern[this.index].id = this.job.id;
            // @ts-ignore
            this.Extern[this.index].amount = this.job.amount;
            // @ts-ignore
            this.Extern[this.index].get_goods = this.job.get_goods;
            // @ts-ignore
            this.Extern[this.index].order_nr = this.job.order_nr;
            // @ts-ignore
            this.Extern[this.index].total_price = this.job.total_price;
            // @ts-ignore
            this.Extern[this.index].date = this.job.date;
            // @ts-ignore
            this.Extern[this.index].supplier = this.job.supplier;
            // @ts-ignore
            this.Extern[this.index].note = this.job.note;
        }
        else {
            this.Extern.push({
                id: this.job.id,
                get_goods: this.job.get_goods,
                amount: this.job.amount,
                order_nr: this.job.order_nr,
                total_price: this.job.total_price,
                date: this.job.date,
                supplier: this.job.supplier,
                note: this.job.note
            });
        }
        this.diaclose();
    }
    editDiaData(item) {
        this.edit = true;
        this.index = this.Extern.indexOf(item);
        // @ts-ignore
        this.job.id = this.Extern[this.index].id;
        // @ts-ignore
        this.job.amount = this.Extern[this.index].amount;
        // @ts-ignore
        this.job.order_nr = this.Extern[this.index].order_nr;
        // @ts-ignore
        this.job.get_goods = this.Extern[this.index].get_goods;
        // @ts-ignore
        this.job.total_price = this.Extern[this.index].total_price;
        // @ts-ignore
        this.job.date = this.Extern[this.index].date;
        // @ts-ignore
        this.job.supplier = this.Extern[this.index].supplier;
        // @ts-ignore
        this.job.note = this.Extern[this.index].note;
        this.diaopen();
    }
    deleteDiaData(item) {
        this.index = this.Extern.indexOf(item);
        this.Extern.splice(this.index, 1);
    }
    diaclose() {
        this.dia = false;
        this.clear();
    }
    clear() {
        this.job = {
            order_nr: "",
            amount: 0,
            total_price: 0,
            order: {},
            supplier: {},
            get_goods: "",
            date: "",
            note: ""
        };
        this.edit = false;
    }
    mounted() {
        this.getSupplierist();
        if (this.$store.getters.isLoggedIn) {
            this.$store.state.monitor = false;
        }
        else {
            this.$store.commit('logout');
        }
    }
};
OutsourceEntrance = __decorate([
    Component({
        name: "OutsourceEntrance",
    })
], OutsourceEntrance);
export default OutsourceEntrance;
